import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarker } from "@fortawesome/free-solid-svg-icons";
import { getList } from "actions/scooter/history/actions";
import { openCustomModal, closeCustomModal } from "views/lib/components/modals";

import CommonTable from "views/lib/components/CommonTable";
import MapPosition from "../trip-active/map-position";

import Filers from "./filters";

const Scooter = ({
                   list,
                   getList,
                   ...rest
                 }) => {
  const handleOpenMap = (position) => {
    if (!position || !Object.keys(position).length) {
      toast("Coordinates not available", {
        type: toast.TYPE.ERROR,
      });
      return null;
    }
    const modalObj = {
      id: "trip-active-position",
      modalSettings: {
        size: "sm"
      },
      header: "Trip position",
      children: (
        <MapPosition
          coordinates={[position.longitude, position.latitude]}
          onCancel={() => rest.closeCustomModal(modalObj)}
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCC-gpzzG6hcmAyagvaYCc23KAy4rIkv2A&v=3.exp&libraries=geometry,drawing,places,visualization"
          loadingElement={<div style={{ height: "100%" }}/>}
          containerElement={<div style={{ height: 400 }}/>}
          mapElement={<div style={{ height: "100%" }}/>}
        />
      ),
      handleClose: () => rest.closeCustomModal(modalObj)
    };
    rest.openCustomModal(modalObj);
  };

  const getColumns = () => [
    {
      id: "id",
      Header: "ID",
      accessor: "id",
    },
    {
      id: "username",
      Header: "Username",
      accessor: "username",
    },
    {
      id: "date",
      Header: "Date",
      accessor: original => moment(original.date)
        .format("HH:mm YYYY-MM-DD"),
      Cell: ({ original }) => moment(original.date)
        .format("HH:mm YYYY-MM-DD"),
    },
    {
      id: "from",
      Header: "Status From",
      accessor: "from",
    },
    {
      id: "to",
      Header: "Status To",
      accessor: "to",
    },
    {
      id: "scooter",
      Header: "Scooter",
      accessor: "scooter",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Link to={`/scooter/scooter/${original.scooterId}`}>
          {original.scooterQr}
        </Link>
      )
    },
    {
      id: "scooter",
      Header: "Scooter QR",
      accessor: "scooterQr",
    },
    {
      id: "position",
      Header: "Position",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <button
          className="btn btn-sm btn-primary"
          onClick={() => handleOpenMap(original.position)}
          title="Bike last position"
        >
          <FontAwesomeIcon icon={faMapMarker}/>
        </button>
      )
    },
  ];

  return (
    <CommonTable
      columns={getColumns()}
      list={list}
      getListFunction={getList}
      FiltersComponent={Filers}
      searchHookProps={{
        size: 20,
        sort: "date,desc"
      }}
    />
  );
};

const mapStateToProps = state => ({
  list: state.scooterHistory.list,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getList: bindActionCreators(getList, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Scooter);



// WEBPACK FOOTER //
// ./src/views/pages/scooter/history/index.js